import React from "react";
import { Zap, Star, TrendingUp } from "lucide-react";
import PhoneMockup from "./PhoneMockup";
import Reveal from "./Reveal";
import { features } from "../mock";

const iconMap = { Zap, Star, TrendingUp };

const Features = () => {
  return (
    <section id="fonctionnalites" className="bg-velis-azure py-16 lg:py-20">
      <div className="max-w-6xl mx-auto px-6 lg:px-10">
        <Reveal className="max-w-3xl mx-auto text-center">
          <h2 className="font-display font-extrabold text-[#14141a] text-3xl sm:text-4xl lg:text-5xl leading-tight">
            {features.title}
          </h2>
          <p className="mt-5 text-[#4a4a55] text-lg leading-relaxed">{features.subtitle}</p>
        </Reveal>

        <div className="mt-12 grid lg:grid-cols-2 gap-12 items-center">
          <Reveal className="flex justify-center">
            <PhoneMockup src={features.image} alt="Écran missions VÉLIS" width={230} />
          </Reveal>

          <div className="space-y-6">
            {features.items.map((item, i) => {
              const Icon = iconMap[item.icon];
              return (
                <Reveal key={item.title} delay={i * 120}>
                  <div className="flex gap-5 rounded-2xl bg-white p-6 shadow-[0_10px_40px_-20px_rgba(0,0,0,0.25)] hover:-translate-y-1 hover:shadow-[0_20px_50px_-24px_rgba(0,0,0,0.35)] transition-all">
                    <div className="shrink-0 w-12 h-12 rounded-xl bg-[var(--velis-orange)]/12 flex items-center justify-center">
                      <Icon className="text-velis-orange" size={22} />
                    </div>
                    <div>
                      <h3 className="font-display font-bold text-[#14141a] text-lg">{item.title}</h3>
                      <p className="mt-1.5 text-[#5a5a66] leading-relaxed">{item.text}</p>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
